import React from 'react';
import { Button, Text } from '@fragments';
import { IconChartBar, IconMovieOff, IconRefresh } from '@tabler/icons-react';
import ReelCard from '../ReelCard';
import './styles.scss';

const SKELETONS = 8;

// The profile's Reels, newest first, a page at a time ("Carregar mais"). The listing reads
// Meta live: while it does, cover-shaped placeholders; when Meta is down it says so with a
// retry, never an empty list. Above them, a line on the comparison by reach the mapping also
// runs (2.5.0) among the latest 100.
export default function ReelGrid({ studio: s, picker, bounds }) {
  const { t, locale } = s;
  const { videos, list, selected, needed } = picker;
  const full = selected.length >= needed;
  if (list.status === 'error' && !videos.length) {
    return <div className="studio-reel-grid__state" role="alert">
      <IconMovieOff aria-hidden="true" />
      <Text.p contrast={7}>{t(`error_${list.error}`, { defaultValue: t('error_generic') })}</Text.p>
      <Button variant="rounded" color="overlay" size="small" startIcon={<IconRefresh />} onClick={picker.reload}>{t('retry')}</Button>
    </div>;
  }
  if (list.status === 'ready' && !videos.length) {
    return <div className="studio-reel-grid__state">
      <IconMovieOff aria-hidden="true" />
      <Text.p contrast={7}>{t('personalityEmpty', { handle: s.profile?.handle })}</Text.p>
    </div>;
  }
  return <div className="studio-reel-grid-wrap">
    <Text.caption className="studio-reel-grid__compare" contrast={6} left={<IconChartBar />}>{t('personalityGridCompare')}</Text.caption>
    <div className="studio-reel-grid" role="group" aria-label={t('personalityGridLabel', { count: needed })} aria-busy={list.status === 'loading' || list.status === 'more'}>
      {videos.map((video, index) => {
        const order = selected.findIndex(item => item.id === video.id) + 1;
        return <ReelCard key={video.id} t={t} locale={locale} video={video} order={order} full={full} bounds={bounds} onToggle={picker.toggle} onRemove={picker.remove}
          style={{ '--studio-reel-index': index % 15 }} />;
      })}
      {(list.status === 'loading' || list.status === 'more') && Array.from({ length: SKELETONS }, (_, index) => <span key={`skeleton-${index}`} className="studio-reel-skeleton" aria-hidden="true"><span /><i /></span>)}
    </div>
    {list.status === 'error' && <Text.caption contrast={7} role="alert">{t(`error_${list.error}`, { defaultValue: t('error_generic') })}</Text.caption>}
    {list.more && list.status !== 'loading' && <div className="studio-reel-grid__more">
      <Button variant="rounded" color="overlay" size="small" preventLoading disabled={list.status === 'more'} onClick={picker.more}>
        {t(list.status === 'error' ? 'retry' : 'personalityLoadMore')}
      </Button>
    </div>}
  </div>;
}
